import { useQuery } from 'react-query';
import { cacheKeys } from 'config';
import { eventsClient } from 'clients/events/eventsClient';

export type Params = {
  id: string;
};

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useEvent = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: event } = {}, status, error } = useQuery(
    [cacheKeys.events.getEvent, params],
    () => eventsClient.getEvent(params.id),
    {
      enabled: options.enabled,
    },
  );

  return {
    status,
    error,
    event,
  };
};
